import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import Footer from "../components/Footer";
import Container from "../components/Container";

import { useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

const MemberAccounts = () => {
  const [open, setOpen] = useState(false);
  const handleSubmit = (event) => {
    event.preventDefault();
    setOpen((prev) => !prev);
  };

  return (
    <>
      <HeaderOriginal></HeaderOriginal>
      <StickyNavBar></StickyNavBar>
      <Container>
        <div className="py-12 md:py-16 lg:py-24">
          <h1 className="font-bold text-lg md:text-xl lg:text-2xl mb-2 md:mb-4 text-[#21497C] text-center">
            حسابات الأعضاء
          </h1>
          <div className="shadow-lg py-6 px-4 md:py-12 md:px-8 lg:py-16 lg:px-10">
            <form
              onSubmit={handleSubmit}
              className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
            >
              <h2 className="mb-2 text-[#408099] font-bold mb-2 md:mb-4">
                تسجيل الدخول
              </h2>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  for="username"
                >
                  معرف الدخول
                  <span className="text-red-500">*</span>
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="username"
                  type="text"
                  placeholder="قم بإدخال رقم الجوال او البريد الإلكتروني"
                  required
                />
              </div>
              <div className="mb-6">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  for="password"
                >
                  كلمة المرور
                  <span className="text-red-500">*</span>
                </label>
                <input
                  //   className="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="password"
                  type="password"
                  placeholder="قم بإدخال كلمة المرور الخاصة بك"
                  required
                />
                {/* <p className="text-red-500 text-base italic">
                  Please choose a password.
                </p> */}
              </div>
              <div className="flex items-center justify-between">
                <button
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="submit"
                >
                  تسجيل الدخول
                </button>
                <button
                  className="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800"
                  onClick={handleSubmit}
                >
                  نسيت كلمة المرور؟
                </button>
              </div>
            </form>
          </div>
        </div>
        <Dialog open={open} onClose={setOpen} className="relative z-10">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
                      <ExclamationTriangleIcon
                        aria-hidden="true"
                        className="size-6 text-red-600"
                      />
                    </div>
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                      <DialogTitle
                        as="h3"
                        className="text-base font-semibold text-gray-900"
                      >
                        صيانة
                      </DialogTitle>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          {/* We're making some improvements to our database to keep
                        it safe and secure. We apologize for any inconvenience
                        this may cause, and we'll get back to you soon. */}
                          نحن نجري بعض التحسينات على قاعدة البيانات الخاصة بنا
                          للحفاظ عليها آمنة ومأمونة. نعتذر عن أي إزعاج قد يسببه
                          هذا ، وسنعاود الاتصال بك قريبا.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row sm:px-6">
                  <button
                    type="button"
                    data-autofocus
                    onClick={() => setOpen(false)}
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  >
                    غلق
                  </button>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
      </Container>
      <Footer></Footer>
    </>
  );
};

export default MemberAccounts;
